<template>
 <!-- Main content -->
 <section class="content">
   <!-- Info boxes -->
   <div class="row">
     <div class="row">
       <div class="col-md-6">
         <div class="box">
           <div class="box-body no-padding table-responsive">
             <table class="table table-striped">
               <thead>
                 <tr>
                  <th style="width: 30px">#</th>
                  <th v-if="flag === 'br'">Parâmetro</th>
                  <th v-else-if="flag === 'de'">Parameter</th>
                  <th v-else-if="flag === 'us'">Parameter</th>
                  <th v-else>Parámetro</th>
                  <th style="width: 50px" v-if="flag === 'br'">Valor</th>
                  <th style="width: 50px" v-else-if="flag === 'de'">Wert</th>
                  <th style="width: 50px" v-else-if="flag === 'us'">Value</th>
                  <th style="width: 50px" v-else>Valor</th>
                 </tr>
               </thead>
               <tbody>
                  <template v-if="flag === 'br'">
                   <tr v-for="registro in  orderBy(filterBy(filterBy(registros, true, 'is_bool'), false, 'is_alarme'), 'labelPtBr')"  :key="registro.id" v-if="registro.is_bool">
                    <td><i :class="registro.icone"></i></td>
                    <td>{{registro.labelPtBr}}</td>
                    <td>
                      <div>
                        <span class="badge bg-green" v-if="registro.valor === 1"><i class="fa fa-arrow-circle-up "></i></span>
                        <span class="badge bg-red" v-else>
                          <i class="fa fa-arrow-circle-down"></i>
                        </span>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else-if="flag === 'de'">
                   <tr v-for="registro in  orderBy(filterBy(filterBy(registros, true, 'is_bool'), false, 'is_alarme'), 'labelDe')"  :key="registro.id" v-if="registro.is_bool">
                    <td><i :class="registro.icone"></i></td>
                    <td>{{registro.labelDe}}</td>
                    <td>
                      <div>
                        <span class="badge bg-green" v-if="registro.valor === 1"><i class="fa fa-arrow-circle-up "></i></span>
                        <span class="badge bg-red" v-else>
                          <i class="fa fa-arrow-circle-down"></i>
                        </span>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else-if="flag === 'us'">
                   <tr v-for="registro in  orderBy(filterBy(filterBy(registros, true, 'is_bool'), false, 'is_alarme'), 'labelEn')"  :key="registro.id" v-if="registro.is_bool">
                    <td><i :class="registro.icone"></i></td>
                    <td>{{registro.labelEn}}</td>
                    <td>
                      <div>
                        <span class="badge bg-green" v-if="registro.valor === 1"><i class="fa fa-arrow-circle-up "></i></span>
                        <span class="badge bg-red" v-else>
                          <i class="fa fa-arrow-circle-down"></i>
                        </span>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                   <tr v-for="registro in  orderBy(filterBy(filterBy(registros, true, 'is_bool'), false, 'is_alarme'), 'labelEs')"  :key="registro.id" v-if="registro.is_bool">
                    <td><i :class="registro.icone"></i></td>
                    <td>{{registro.labelEs}}</td>
                    <td>
                      <div>
                        <span class="badge bg-green" v-if="registro.valor === 1"><i class="fa fa-arrow-circle-up "></i></span>
                        <span class="badge bg-red" v-else>
                          <i class="fa fa-arrow-circle-down"></i>
                        </span>
                      </div>
                    </td>
                  </tr>
                </template>
               </tbody>
             </table>
           </div>
         </div>
       </div>
       <div class="col-md-6">
         <div class="box">
           <div class="box-body no-padding table-responsive">
             <table class="table table-striped">
               <thead>
                 <tr>
                  <th style="width: 30px">#</th>
                  <th v-if="flag === 'br'">Parâmetro</th>
                  <th v-else-if="flag === 'de'">Parameter</th>
                  <th v-else-if="flag === 'us'">Parameter</th>
                  <th v-else>Parámetro</th>
                  <th style="width: 100px" v-if="flag === 'br'">Valor</th>
                  <th style="width: 100px" v-else-if="flag === 'de'">Wert</th>
                  <th style="width: 100px" v-else-if="flag === 'us'">Value</th>
                  <th style="width: 100px" v-else>Valor</th>
                  <th style="width: 50px" v-if="flag === 'br'">Histórico</th>
                  <th style="width: 50px" v-else-if="flag === 'de'">Geschichte</th>
                  <th style="width: 50px" v-else-if="flag === 'us'">Historic</th>
                  <th style="width: 50px" v-else>Historia</th>
                 </tr>
               </thead>
               <tbody>
                  <template v-if="flag === 'br'">
                    <tr v-for="registro in orderBy(registros, 'labelPtBr')"  :key="registro.id" v-if="!registro.is_bool">
                      <td><i :class="registro.icone"></i></td>
                      <td>{{registro.labelPtBr}}</td>
                      <td>
                        <div class="float-right">
                         <span class="text-uppercase">
                          {{registro.valor | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}} {{registro.unidade_medida}}
                         </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span class="badge bg-teal" v-if="registro.registrado == true"><i class="fa fa-check"></i></span>
                        </div>
                      </td>
                     </tr>
                  </template>
                  <template v-else-if="flag === 'de'">
                    <tr v-for="registro in orderBy(registros, 'labelDe')"  :key="registro.id" v-if="!registro.is_bool">
                      <td><i :class="registro.icone"></i></td>
                      <td>{{registro.labelDe}}</td>
                      <td>
                        <div class="float-right">
                         <span class="text-uppercase">
                          {{registro.valor | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}} {{registro.unidade_medida}}
                         </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span class="badge bg-teal" v-if="registro.registrado == true"><i class="fa fa-check"></i></span>
                        </div>
                      </td>
                     </tr>
                  </template>
                  <template v-else-if="flag === 'us'">
                    <tr v-for="registro in orderBy(registros, 'labelEn')"  :key="registro.id" v-if="!registro.is_bool">
                      <td><i :class="registro.icone"></i></td>
                      <td>{{registro.labelEn}}</td>
                      <td>
                        <div class="float-right">
                         <span class="text-uppercase">
                          {{registro.valor | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}} {{registro.unidade_medida}}
                         </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span class="badge bg-teal" v-if="registro.registrado == true"><i class="fa fa-check"></i></span>
                        </div>
                      </td>
                     </tr>
                  </template>
                  <template v-else>
                    <tr v-for="registro in orderBy(registros, 'labelEs')"  :key="registro.id" v-if="!registro.is_bool">
                      <td><i :class="registro.icone"></i></td>
                      <td>{{registro.labelEs}}</td>
                      <td>
                        <div class="float-right">
                         <span class="text-uppercase">
                          {{registro.valor | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}} {{registro.unidade_medida}}
                         </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span class="badge bg-teal" v-if="registro.registrado == true"><i class="fa fa-check"></i></span>
                        </div>
                      </td>
                     </tr>
                  </template>
               </tbody>
             </table>
           </div>
         </div>
       </div>
     </div>
     <!-- /.col -->
     <!-- fix for small devices only -->
     <div class="clearfix visible-sm-block"></div>
   </div>
   <!-- /.row -->

   <!-- /.row -->

   <!-- Main row -->
   <div class="row">
   <!-- /.row -->
 </div>
 </section>
 <!-- /.content -->
</template>

<script>
import {firebaseApp} from '../../helpers/firebaseApp'
import Vue2Filters from 'vue2-filters'

var db = firebaseApp.database()
var sd022020Ref = db.ref('sd022020')

export default {
  mixins: [Vue2Filters.mixin],
  data () {
    return {
      registros: [],
      generateRandomNumbers (numbers, max, min) {
        var a = []
        for (var i = 0; i < numbers; i++) {
          a.push(Math.floor(Math.random() * (max - min + 1)) + max)
        }
        return a
      }
    }
  },
  firebase: {
    registros: sd022020Ref
  },
  computed: {
    flag () {
      return this.$store.state.flag
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  },
  methods: {
    track () {
      this.$ga.page('/manutencao')
    }
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Manutencao.vue?15ce4f69